export class Base62 {
  private static readonly CHARSET =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

  static encode(num: number): string {
    if (num === 0) return this.CHARSET[0];
    let encoded = '';
    while (num > 0) {
      encoded = this.CHARSET[num % 62] + encoded;
      num = Math.floor(num / 62);
    }
    return encoded;
  }

  static decode(str: string): number {
    let decoded = 0;
    for (let i = 0; i < str.length; i++) {
      decoded = decoded * 62 + this.CHARSET.indexOf(str[i]);
    }
    return decoded;
  }
}
